// extracted by mini-css-extract-plugin
export default {"field-label":"styles_field-label__IFGqF","error-input-name":"styles_error-input-name__ck42k"};